module.exports = __webpack_public_path__ + "brand-icons.c5ebe0b32dc1b5cc449a.ttf";


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/assets/semantic/themes/default/assets/fonts/brand-icons.ttf
// module id = ../../../../../src/assets/semantic/themes/default/assets/fonts/brand-icons.ttf
// module chunks = styles